import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "../globalStyles/scss/index.scss";
import classNames from "classnames";
import React, { useEffect } from "react";
import { useLocation, useRouteMatch } from "react-router-dom";
import { PrismicFooter } from "../@prismic/components/PrismicFooter";
import { TopBar } from "../@prismic/components/TopBar";
import { PrismicLayoutContext } from "../@prismic/templates/PrismicLayout/context";
import { usePrismicLayoutQuery } from "../@prismic/templates/PrismicLayout/hooks/usePrismicLayout";
import { MainMenu, MetaConsumer, OverlayManager } from "../components";
import { ErrorBoundary } from "../components/ErrorBoundary";
import { useScrolled } from "../hooks";
import { RudderAnalytics } from "./analitics";
import { Routes } from "./routes";

var App = function App() {
  var location = useLocation();

  var _usePrismicLayoutQuer = usePrismicLayoutQuery(),
      data = _usePrismicLayoutQuer.data;

  var isCheckout = !!useRouteMatch("/checkout");
  var isThankYouPage = !!useRouteMatch("/order-finalized");
  var hideMenu = isCheckout || isThankYouPage;

  var _ref = (data === null || data === void 0 ? void 0 : data.layout) || {},
      header_message = _ref.header_message,
      header_navigation = _ref.header_navigation,
      header_navigation_all_types_image = _ref.header_navigation_all_types_image,
      footer_contact_title = _ref.footer_contact_title,
      footer_contact_text = _ref.footer_contact_text,
      footer_copyright = _ref.footer_copyright,
      footer_navigation = _ref.footer_navigation,
      footer_trust_box = _ref.footer_trust_box,
      footer_terms = _ref.footer_terms,
      footer_social = _ref.footer_social,
      contact = _ref.contact;

  useEffect(function () {
    // const currentPath = location.pathname;
    // TagManager.dataLayer({
    //   dataLayer: {
    //     event: "Pageview",
    //     pagePath: currentPath,
    //   },
    // });
    // // TODO: check if we need to pass the currentPath
    RudderAnalytics.page();
  }, [location]);

  var _useScrolled = useScrolled(350, 600),
      _useScrolled2 = _slicedToArray(_useScrolled, 1),
      isScrolled = _useScrolled2[0];

  return React.createElement(ErrorBoundary, null, React.createElement(MetaConsumer, null), React.createElement(PrismicLayoutContext.Provider, {
    value: {
      layout: data === null || data === void 0 ? void 0 : data.layout
    }
  }, React.createElement("header", null, !hideMenu && React.createElement(React.Fragment, null, React.createElement(TopBar, {
    contact: contact,
    message: header_message,
    isScrolled: isScrolled
  }), React.createElement(MainMenu, {
    prismicNav: header_navigation,
    allTypesImage: header_navigation_all_types_image // TODO: add all_types_label also
    ,
    contact: contact,
    isScrolled: isScrolled
  }))), hideMenu, React.createElement("div", {
    className: classNames("page-wrapper", {
      "no-margin": hideMenu
    })
  }, React.createElement(Routes, null)), !hideMenu && React.createElement(PrismicFooter, {
    title: footer_contact_title,
    contact: contact,
    text: footer_contact_text,
    social: footer_social,
    navGroups: footer_navigation,
    isTrustBoxEnabled: footer_trust_box,
    copyright: footer_copyright,
    terms: footer_terms
  }), React.createElement(OverlayManager, null)));
};

export default App;